// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Admin Dashboard - Modern User-Friendly Design
 * Professional, clean, and highly user-friendly admin dashboard styling
 */

.admin-dashboard {
  min-height: 100vh;
  background: #f9fafb;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  line-height: 1.6;
}

/* Admin Dashboard Header Integration - Removed duplicate styles, handled by AdminDashboardHeader.css */

/* Dashboard Stats */
.dashboard-stats {
  max-width: 1400px;
  margin: 2rem auto 4rem auto;
  padding: 0 1rem;
  width: 100%;
}

/* Stats margin adjustment */
.admin-dashboard .dashboard-stats {
  margin-top: 2rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  max-width: 100%;
  width: 100%;
  min-width: 0;
}

/* Force single row on larger screens */
@media (min-width: 1025px) {
  .stats-grid {
    display: flex;
    flex-wrap: nowrap;
    gap: 1rem;
  }

  .stat-card {
    flex: 1 1;
    min-width: 0;
  }
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 100px;
  max-width: 100%;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #EA580C, #FDBA74);
}

.stat-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px -4px rgba(0, 0, 0, 0.12), 0 6px 8px -2px rgba(0, 0, 0, 0.08);
  border-color: #d1d5db;
}

.stat-card:hover .stat-icon {
  transform: scale(1.05);
  box-shadow: 0 6px 12px -1px rgba(79, 70, 229, 0.25), 0 4px 6px -1px rgba(79, 70, 229, 0.15);
}

.stat-icon {
  font-size: 1.75rem;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border-radius: 12px;
  color: white;
  box-shadow: 0 3px 6px -1px rgba(79, 70, 229, 0.15), 0 2px 4px -1px rgba(79, 70, 229, 0.08);
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-content h3 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 0.25rem 0;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.stat-content p {
  color: #6b7280;
  margin: 0;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  line-height: 1.2;
}

/* Dashboard Sections */
.dashboard-sections {
  max-width: 1200px;
  margin: 0 auto 4rem auto;
  padding: 0 2rem;
}

.sections-header {
  text-align: center;
  margin-bottom: 4rem;
}

.sections-header h2 {
  font-size: 2.5rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 1rem 0;
  letter-spacing: -0.025em;
}

.sections-header p {
  font-size: 1.125rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.sections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 2.5rem;
}

.section-card {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.section-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-color: #d1d5db;
}

.section-card.blue {
  border-left: 4px solid #EA580C;
  background: white;
}

.section-card.blue:hover {
  border-left-color: #4338ca;
  background: #f8fafc;
}

.section-card.green {
  border-left: 4px solid #FDBA74;
  background: white;
}

.section-card.green:hover {
  border-left-color: #0d9488;
  background: #f0fdfa;
}

.section-card.purple {
  border-left: 4px solid #8b5cf6;
  background: white;
}

.section-card.purple:hover {
  border-left-color: #7c3aed;
  background: #faf5ff;
}

.section-card.orange {
  border-left: 4px solid #f59e0b;
  background: white;
}

.section-card.orange:hover {
  border-left-color: #d97706;
  background: #fffbeb;
}

.section-card.teal {
  border-left: 4px solid #FDBA74;
  background: white;
}

.section-card.teal:hover {
  border-left-color: #0d9488;
  background: #f0fdfa;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.card-icon {
  font-size: 2.5rem;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border-radius: 18px;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.1), 0 2px 4px -1px rgba(79, 70, 229, 0.06);
  flex-shrink: 0;
}

.card-stats {
  background: #f3f4f6;
  color: #6b7280;
  padding: 0.5rem 1rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.card-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 1rem 0;
  letter-spacing: -0.025em;
}

.card-content p {
  color: #6b7280;
  margin: 0 0 2rem 0;
  line-height: 1.6;
  font-size: 0.95rem;
  font-weight: 500;
  flex-grow: 1;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.action-text {
  color: #EA580C;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.action-arrow {
  font-size: 1.25rem;
  color: #EA580C;
  transition: transform 0.3s ease;
}

.section-card:hover .action-arrow {
  transform: translateX(4px);
}

.card-hover-effect {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.05), rgba(20, 184, 166, 0.05));
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.section-card:hover .card-hover-effect {
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 0.75rem;
  }

  .stat-card {
    padding: 1.25rem;
    min-height: 90px;
  }

  .stat-icon {
    width: 44px;
    height: 44px;
    font-size: 1.5rem;
  }

  .stat-content h3 {
    font-size: 1.5rem;
  }

  .stat-content p {
    font-size: 0.7rem;
  }
}

@media (max-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .stat-card {
    padding: 1.5rem;
    min-height: 100px;
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    font-size: 1.75rem;
  }

  .stat-content h3 {
    font-size: 1.75rem;
  }

  .sections-grid {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .admin-dashboard .dashboard-stats {
    margin-top: 1rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .stat-card {
    padding: 1.5rem;
    min-height: 100px;
  }

  .sections-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .dashboard-stats,
  .dashboard-sections {
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .stat-card {
    padding: 1.25rem;
    min-height: 90px;
  }

  .stat-icon {
    width: 44px;
    height: 44px;
    font-size: 1.5rem;
  }

  .stat-content h3 {
    font-size: 1.5rem;
  }

  .stat-content p {
    font-size: 0.75rem;
  }

  .section-card {
    padding: 1.5rem;
  }

  .sections-header h2 {
    font-size: 2rem;
  }
}

/* Recent Activity Section - Enhanced */
.recent-activity-section {
  max-width: 1400px;
  margin: 0 auto 4rem auto;
  padding: 0 2rem;
}

.activity-header {
  text-align: center;
  margin-bottom: 3rem;
}

.activity-header h2 {
  font-size: 2.25rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 0.75rem 0;
  letter-spacing: -0.025em;
}

.activity-header p {
  font-size: 1.125rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.activity-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.activity-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-color: #d1d5db;
}

.activity-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.activity-icon {
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border-radius: 12px;
  color: white;
  box-shadow: 0 2px 4px -1px rgba(79, 70, 229, 0.1);
  flex-shrink: 0;
}

.activity-card-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  flex-grow: 1;
}

.activity-count {
  background: #f3f4f6;
  color: #6b7280;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.activity-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
}

.activity-item:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.activity-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.activity-content {
  flex-grow: 1;
  min-width: 0;
}

.activity-name {
  font-weight: 600;
  color: #111827;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.activity-email {
  color: #6b7280;
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
  word-break: break-all;
}

.activity-time {
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 500;
}

.activity-status {
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.activity-status.pending {
  background: #fef3c7;
  color: #d97706;
}

.activity-status.approved {
  background: #d1fae5;
  color: #059669;
}

.activity-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
  text-align: center;
}

.activity-footer span {
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Responsive Design for Activity Section */
@media (max-width: 768px) {
  .activity-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .activity-card {
    padding: 1.5rem;
  }

  .recent-activity-section {
    padding: 0 1rem;
  }

  .activity-header h2 {
    font-size: 1.875rem;
  }

  .activity-item {
    padding: 0.75rem;
  }

  .activity-avatar {
    width: 36px;
    height: 36px;
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .activity-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .activity-card-header h3 {
    font-size: 1.125rem;
  }

  .activity-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .activity-content {
    width: 100%;
  }

  .activity-status {
    align-self: flex-end;
  }
}

/* Focus states for accessibility */
.section-card:focus {
  outline: 3px solid rgba(102, 126, 234, 0.5);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/AdminDashboard.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,yFAAyF;EACzF,gBAAgB;AAClB;;AAEA,uGAAuG;;AAEvG,oBAAoB;AACpB;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wEAAwE;EACxE,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,oFAAoF;EACpF,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,2FAA2F;AAC7F;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,0FAA0F;EAC1F,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uEAAuE;EACvE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sFAAsF;EACtF,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,iFAAiF;EACjF,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,mCAAmC;AACnC;EACE,2CAA2C;EAC3C,mBAAmB;AACrB","sourcesContent":["/**\n * Admin Dashboard - Modern User-Friendly Design\n * Professional, clean, and highly user-friendly admin dashboard styling\n */\n\n.admin-dashboard {\n  min-height: 100vh;\n  background: #f9fafb;\n  padding: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  line-height: 1.6;\n}\n\n/* Admin Dashboard Header Integration - Removed duplicate styles, handled by AdminDashboardHeader.css */\n\n/* Dashboard Stats */\n.dashboard-stats {\n  max-width: 1400px;\n  margin: 2rem auto 4rem auto;\n  padding: 0 1rem;\n  width: 100%;\n}\n\n/* Stats margin adjustment */\n.admin-dashboard .dashboard-stats {\n  margin-top: 2rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  max-width: 100%;\n  width: 100%;\n  min-width: 0;\n}\n\n/* Force single row on larger screens */\n@media (min-width: 1025px) {\n  .stats-grid {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 1rem;\n  }\n\n  .stat-card {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n.stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);\n  border: 1px solid #e5e7eb;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  min-height: 100px;\n  max-width: 100%;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #EA580C, #FDBA74);\n}\n\n.stat-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 28px -4px rgba(0, 0, 0, 0.12), 0 6px 8px -2px rgba(0, 0, 0, 0.08);\n  border-color: #d1d5db;\n}\n\n.stat-card:hover .stat-icon {\n  transform: scale(1.05);\n  box-shadow: 0 6px 12px -1px rgba(79, 70, 229, 0.25), 0 4px 6px -1px rgba(79, 70, 229, 0.15);\n}\n\n.stat-icon {\n  font-size: 1.75rem;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border-radius: 12px;\n  color: white;\n  box-shadow: 0 3px 6px -1px rgba(79, 70, 229, 0.15), 0 2px 4px -1px rgba(79, 70, 229, 0.08);\n  flex-shrink: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.stat-content h3 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #111827;\n  margin: 0 0 0.25rem 0;\n  letter-spacing: -0.025em;\n  line-height: 1.2;\n}\n\n.stat-content p {\n  color: #6b7280;\n  margin: 0;\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  line-height: 1.2;\n}\n\n/* Dashboard Sections */\n.dashboard-sections {\n  max-width: 1200px;\n  margin: 0 auto 4rem auto;\n  padding: 0 2rem;\n}\n\n.sections-header {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n.sections-header h2 {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #111827;\n  margin: 0 0 1rem 0;\n  letter-spacing: -0.025em;\n}\n\n.sections-header p {\n  font-size: 1.125rem;\n  color: #6b7280;\n  margin: 0;\n  font-weight: 500;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.sections-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 2.5rem;\n}\n\n.section-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2.5rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.section-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-color: #d1d5db;\n}\n\n.section-card.blue {\n  border-left: 4px solid #EA580C;\n  background: white;\n}\n\n.section-card.blue:hover {\n  border-left-color: #4338ca;\n  background: #f8fafc;\n}\n\n.section-card.green {\n  border-left: 4px solid #FDBA74;\n  background: white;\n}\n\n.section-card.green:hover {\n  border-left-color: #0d9488;\n  background: #f0fdfa;\n}\n\n.section-card.purple {\n  border-left: 4px solid #8b5cf6;\n  background: white;\n}\n\n.section-card.purple:hover {\n  border-left-color: #7c3aed;\n  background: #faf5ff;\n}\n\n.section-card.orange {\n  border-left: 4px solid #f59e0b;\n  background: white;\n}\n\n.section-card.orange:hover {\n  border-left-color: #d97706;\n  background: #fffbeb;\n}\n\n.section-card.teal {\n  border-left: 4px solid #FDBA74;\n  background: white;\n}\n\n.section-card.teal:hover {\n  border-left-color: #0d9488;\n  background: #f0fdfa;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 2rem;\n}\n\n.card-icon {\n  font-size: 2.5rem;\n  width: 72px;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border-radius: 18px;\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.1), 0 2px 4px -1px rgba(79, 70, 229, 0.06);\n  flex-shrink: 0;\n}\n\n.card-stats {\n  background: #f3f4f6;\n  color: #6b7280;\n  padding: 0.5rem 1rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.card-content h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 1rem 0;\n  letter-spacing: -0.025em;\n}\n\n.card-content p {\n  color: #6b7280;\n  margin: 0 0 2rem 0;\n  line-height: 1.6;\n  font-size: 0.95rem;\n  font-weight: 500;\n  flex-grow: 1;\n}\n\n.card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: auto;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.action-text {\n  color: #EA580C;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.action-arrow {\n  font-size: 1.25rem;\n  color: #EA580C;\n  transition: transform 0.3s ease;\n}\n\n.section-card:hover .action-arrow {\n  transform: translateX(4px);\n}\n\n.card-hover-effect {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.05), rgba(20, 184, 166, 0.05));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.section-card:hover .card-hover-effect {\n  opacity: 1;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .stats-grid {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0.75rem;\n  }\n\n  .stat-card {\n    padding: 1.25rem;\n    min-height: 90px;\n  }\n\n  .stat-icon {\n    width: 44px;\n    height: 44px;\n    font-size: 1.5rem;\n  }\n\n  .stat-content h3 {\n    font-size: 1.5rem;\n  }\n\n  .stat-content p {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n\n  .stat-card {\n    padding: 1.5rem;\n    min-height: 100px;\n  }\n\n  .stat-icon {\n    width: 48px;\n    height: 48px;\n    font-size: 1.75rem;\n  }\n\n  .stat-content h3 {\n    font-size: 1.75rem;\n  }\n\n  .sections-grid {\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-dashboard .dashboard-stats {\n    margin-top: 1rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .stat-card {\n    padding: 1.5rem;\n    min-height: 100px;\n  }\n\n  .sections-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .dashboard-stats,\n  .dashboard-sections {\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .stat-card {\n    padding: 1.25rem;\n    min-height: 90px;\n  }\n\n  .stat-icon {\n    width: 44px;\n    height: 44px;\n    font-size: 1.5rem;\n  }\n\n  .stat-content h3 {\n    font-size: 1.5rem;\n  }\n\n  .stat-content p {\n    font-size: 0.75rem;\n  }\n\n  .section-card {\n    padding: 1.5rem;\n  }\n\n  .sections-header h2 {\n    font-size: 2rem;\n  }\n}\n\n/* Recent Activity Section - Enhanced */\n.recent-activity-section {\n  max-width: 1400px;\n  margin: 0 auto 4rem auto;\n  padding: 0 2rem;\n}\n\n.activity-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.activity-header h2 {\n  font-size: 2.25rem;\n  font-weight: 800;\n  color: #111827;\n  margin: 0 0 0.75rem 0;\n  letter-spacing: -0.025em;\n}\n\n.activity-header p {\n  font-size: 1.125rem;\n  color: #6b7280;\n  margin: 0;\n  font-weight: 500;\n  max-width: 500px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.activity-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 2rem;\n}\n\n.activity-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.activity-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-color: #d1d5db;\n}\n\n.activity-card-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.activity-icon {\n  font-size: 1.5rem;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border-radius: 12px;\n  color: white;\n  box-shadow: 0 2px 4px -1px rgba(79, 70, 229, 0.1);\n  flex-shrink: 0;\n}\n\n.activity-card-header h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  flex-grow: 1;\n}\n\n.activity-count {\n  background: #f3f4f6;\n  color: #6b7280;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.activity-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  transition: all 0.2s ease;\n}\n\n.activity-item:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.activity-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.activity-content {\n  flex-grow: 1;\n  min-width: 0;\n}\n\n.activity-name {\n  font-weight: 600;\n  color: #111827;\n  font-size: 0.875rem;\n  margin-bottom: 0.25rem;\n}\n\n.activity-email {\n  color: #6b7280;\n  font-size: 0.75rem;\n  margin-bottom: 0.25rem;\n  word-break: break-all;\n}\n\n.activity-time {\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.activity-status {\n  padding: 0.25rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex-shrink: 0;\n}\n\n.activity-status.pending {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.activity-status.approved {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.activity-footer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n  text-align: center;\n}\n\n.activity-footer span {\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n/* Responsive Design for Activity Section */\n@media (max-width: 768px) {\n  .activity-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .activity-card {\n    padding: 1.5rem;\n  }\n\n  .recent-activity-section {\n    padding: 0 1rem;\n  }\n\n  .activity-header h2 {\n    font-size: 1.875rem;\n  }\n\n  .activity-item {\n    padding: 0.75rem;\n  }\n\n  .activity-avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .activity-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .activity-card-header h3 {\n    font-size: 1.125rem;\n  }\n\n  .activity-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .activity-content {\n    width: 100%;\n  }\n\n  .activity-status {\n    align-self: flex-end;\n  }\n}\n\n/* Focus states for accessibility */\n.section-card:focus {\n  outline: 3px solid rgba(102, 126, 234, 0.5);\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
